export const apiName: string = 'meses-licenciamentos';
export const licenciamentosRoute: string = 'mes-licenciamentos';
export const licenciamentosStorage: string = 'mes-licenciamentos';
export const licenciamentosModuleName: any = {plural: 'Meses de licenciamento', single: 'Mês de licenciamento'};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/shared/data.service.ts
 **/